import { ORGANIZATION_TYPES, REGEX_EXPS } from "utils/constants";
import * as yup from "yup";

const validator = (messages) => {
  const requiredString = yup
    .string()
    .typeError(messages.REQUIRED)
    .required(messages.REQUIRED);

  const requiredName = yup
    .string()
    .typeError(messages.REQUIRED)
    .matches(REGEX_EXPS.name, messages.INVALID_NAME)
    .required(messages.REQUIRED);

  return yup.object().shape({
    organization: yup.object().shape({
      name: requiredString,
      siretNumber: yup.mixed().when("type", {
        is: ORGANIZATION_TYPES.OTHER,
        then: yup
          .string()
          .typeError(messages.REQUIRED)
          .matches(/^\d{14}$/, messages.EXACT_LENGTH.replace("{length}", "14"))
          .required(messages.REQUIRED),
      }),
    }),
    user: yup.object().shape({
      firstname: requiredName,
      lastname: requiredName,
      email: yup
        .string()
        .typeError(messages.REQUIRED)
        .email(messages.EMAIL)
        .required(messages.REQUIRED),
      phone: yup
        .string()
        .nullable()
        .test("isValid", messages.INVALID_VALUE, function (value) {
          if (!value) return true;
          return new RegExp(REGEX_EXPS.phone).test(value);
        }),
    }),
  });
};

export default validator;
